const initialState = () => ({
  cards: [],
});

const state = initialState();

export default state;
